module.exports = {
  message: {
    key: 'message',
    label: 'Message',
  },
  channel: {
    key: 'channel',
    label: 'Channel',
  },
  bodySiteCanvas: {
    key: 'bodySiteCanvas',
    label: 'Body Site Canvas',
  },
  imageCanvas: {
    key: 'imageCanvas',
    label: 'Image Canvas',
  },
  image: {
    key: 'image',
    label: 'Image',
  },
  conditionAnnotation: {
    key: 'conditionAnnotation',
    label: 'Condition Notes',
  },
  bodySiteAnnotation: {
    key: 'bodySiteAnnotation',
    label: 'Body Site Notes',
  },
  imageAnnotation: {
    key: 'imageAnnotation',
    label: 'Image Notes',
  },
  calendarObjectInvite: {
    key: 'calendarObjectInvite',
    label: 'Calendar Invite',
  },
};